import styled from "styled-components"

export const Wrap = styled.div`
  height: 100%;
  width: 65%;
  flex-direction: column;
  text-align: left;

  position: relative;
  margin: 0 0 0 35%;

  input:focus,
  select:focus,
  textarea:focus,
  button:focus {
    outline: none;
  }

  @media screen and (max-width: 979px) {
    width: 100%;
    margin: 0;
  }
`

export const Center = styled.div`
  width: 90%;
  margin: -3.5em auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media screen and (max-width: 800px) {
    width: 65%;
    flex-direction: column;
  }
`
export const Details = styled.div`
  flex: 1;
  padding-right: 2rem;
  margin: 1em 0 2em 0;

  @media (max-width: 960px) {
    padding-right: unset;
    width: 100%;
    order: 1;
  }

  h1 {
    margin-bottom: 2rem;
    font-size: 26pt;
    color: #212121;
  }

  p {
    font-family: "Quicksand", sans-serif;
    font-weight: 300;
    margin-bottom: 2.5rem;
    font-size: 20pt;
    line-height: 1.3;
    color: #707070;
  }
`

export const Thumbnail = styled.div`
  flex: 1;

  @media (max-width: 960px) {
    width: 100%;
    margin-bottom: 0rem;
  }

  img {
    width: 100%;
  }
`
